$(document).ready(function () {  
  readMore();
  announcementSlider();
  productFeaturedSlider();
  customFilterBlogs();
  if($('.template-product')) {
    getShippingRates();
  }
  
});


function readMore() {
  $('body').on('click', '.js-read-more', function(e){
    e.stopImmediatePropagation();
    e.preventDefault();
    if ($('.show-hide-text').hasClass('show')) {
      $('.show-hide-text').removeClass('show');
      $('.read-more').text('Learn more');
    } else {
      $('.show-hide-text').addClass('show');
      $('.read-more').text('See less');
    }
  });
}

function announcementSlider() {
  if($(window).width() < 767){
    if ($('.announcement-bar .announcement-slider')) {
      let item = $('.announcement-bar .announcement-slider').data('item-mobile');
      $('.announcement-bar .announcement-slider').slick({
        slidesToShow: item,
        slidesToScroll: item,
        autoplay: true,
        autoplaySpeed: 4000,
      });
    }
    if ($('.toolbar .announcement-slider')) {
      let item1 = $('.toolbar .announcement-slider').data('item-mobile');
      $('.toolbar .announcement-slider').slick({
        slidesToShow: item1,
        slidesToScroll: item1,
        autoplay: true,
        autoplaySpeed: 5000,
      });
    }
  }
}

function productFeaturedSlider() {
  $('div[data-section-type="collection-template"] .product_featured--slide').slick({
    arrows: true,
    adaptiveHeight: true,
    responsive: [
      {
        breakpoint: 1200,
        settings: {
          slidesToShow: 4,
          slidesToScroll: 4
        }
      },
      {
        breakpoint: 1025,
        settings: {
          slidesToShow: 3,
          slidesToScroll: 3
        }
      },
      {
        breakpoint: 600,
        settings: {
          slidesToShow: 2,
          slidesToScroll: 2,
        
        }
      }
    ]
  }) 
}

function customFilterBlogs() {
  let allTags = $('#custom-blog-filter .itemTag');

  if (allTags.length > 0) {
    allTags.click(function() {
      let thisTag = $(this).attr('data-value');
      $('#BlogTagFilter')
      .val(thisTag)
      .trigger('change');
    }) 
  }
}

function getShippingRates() {
	var cartCookie;
	/* The ID of the element that you want to add the shipping fields into */
	var productSection = document.getElementsByClassName('product-single__meta');
	if(!productSection.length){ return }

	/* the main product select element */
	var productSelect = document.querySelector('select.product-single__variants');
	if(!productSelect){ return }

  var shippingCalcButton = productSection[0].querySelector('.btn-getRates');
  var parentElm = shippingCalcButton.closest('.product-single__meta');
	var shippingMessage = parentElm.querySelector('p.message');
	var shippingCountry = parentElm.querySelector('input[name="shipping_address[country]"]');
  var shippingCity = parentElm.querySelector('input[name="shipping_address[city]"]');
	var shippingProvince = parentElm.querySelector('select[name="shipping_address[province]"]');
	var shippingZip = parentElm.querySelector('input[name="shipping_address[zip]"]');

	/* We are just adding some dummy fields for example only. There's better ways to handle this */
	var initFields = function(){
		shippingCalcButton.onclick=function(){
			if(!productSelect.value.length){ return false }
			cartCookie = getCookie('cart');
			var tempCookieValue = tempCookieValue || "temp-cart-cookie___" + Date.now();
			var fakeCookieValue = fakeCookieValue || "fake-cart-cookie___" + Date.now();

			/* if not found, make a new temp cookie */
			if(!cartCookie){ 
				updateCartCookie(tempCookieValue);
				cartCookie = getCookie('cart');
			}else{
				console.log('cookie found');
			}

			/* if found but has a weird length, bail */
			if(cartCookie.length < 32){return }

			/* Change the cookie value to a new 32 character value */
			updateCartCookie(fakeCookieValue);
      var cartErr = 0;
      var cartErrNote = '';
      if (!shippingZip.value && !shippingCity.value ) {
        cartErrNote = 'Please enter your City and Postcode';
        cartErr = 1;
      }
      else if(!shippingZip.value) {
        cartErrNote = 'Please enter your Postcode';
        cartErr = 1;
      }
      else if(!shippingCity.value) {
        cartErrNote = 'Please enter your City';
        cartErr = 1;
      }
      else if(!shippingProvince.value) {
        cartErrNote = 'Please enter your State';
        cartErr = 1;
      }

      else if(!shippingCountry.value) {
        cartErrNote = 'Please enter your Country';
        cartErr = 1;
      }

      else {
        cartErrNote = '';
        cartErr = 0;
      }
      
      if (cartErr == 0) {
        shippingMessage.classList.remove('error');
        getRates(parseInt(productSelect.value));
      }
      else {
        shippingMessage.innerHTML = cartErrNote;
        shippingMessage.classList.add('error');
      }
		
			return false;
		};

	};

	/* get cookie by name */
	var getCookie = function(name) {
		var value = "; " + document.cookie;
		var parts = value.split('; ' + name + '=');
		if (parts.length == 2) return parts.pop().split(";").shift();
	};

	/* update the cart cookie value */
	var updateCartCookie = function(a) {
		var date = new Date();
		date.setTime(date.getTime() + (14 * 86400000));
		var expires = '; expires=' + date.toGMTString();
		document.cookie = 'cart=' + a + expires + '; path=/';
	};

	/* reset the cart cookie value */
	var resetCartCookie = function(){
		updateCartCookie(cartCookie);
	};

	/* get the rates */
	var getRates = function(variantId){
		/* add whatever sanity checks you need in addition to the one below */
		if(typeof variantId === 'undefined'){ return }

		/* the main quantity element */
		var productQuantity = document.querySelector('.product-buttons .js-qty__num');

		var quantity = productQuantity ? parseInt(productQuantity.value) : 1;
		var addData = {
			'id' : variantId,
			'quantity' : quantity
		};
    
    var shippingAddress = {};
    shippingAddress.country = shippingCountry.value;
    shippingAddress.province = shippingProvince.value;
    shippingAddress.city = shippingCity.value;
    shippingAddress.zip = shippingZip.value;

    var queryString = Object.keys(shippingAddress).map(function (key) {
      return "".concat(encodeURIComponent("shipping_address[".concat(key, "]")), "=").concat(encodeURIComponent(shippingAddress[key]));
    }).join('&');

		fetch('/cart/add.js', {
			body: JSON.stringify(addData),
			credentials: 'same-origin',
			headers: {
				'Content-Type': 'application/json',
				'X-Requested-With':'xmlhttprequest'
			},
			method: 'POST'
		}).then(function(response) {
			return response.json();
		}).then(function(json) {
			/* Change the cookie value back to what it was */
			$.ajax({
				type: "GET",
				url: '/cart/shipping_rates.json?'.concat(queryString),
				success: function(result){
          console.log(result);
					if(result.shipping_rates && result.shipping_rates.length){
            let arr = result.shipping_rates;
            arr.map(function(shipping_rates) {
              console.log(shipping_rates);
              shippingMessage.classList.remove('error');
              shippingMessage.innerHTML = shipping_rates.name + ' : $' + shipping_rates.price;
            })
          }
					resetCartCookie();
				},
				error: function(err){
					resetCartCookie();
          shippingMessage.classList.add('error');
					shippingMessage.innerHTML = err.responseText;
				},
				dataType: 'json'
			});
 
			
		}).catch(function(err) {
			/* uh oh, we have error. */
			resetCartCookie()
		});
	};

	initFields();
}

function getShippingRatesCartDraw(btn, parentDiv) {
  let parentElm = btn.closest(parentDiv);
  let shippingMessage = parentElm.querySelector('p.message');
  let shippingCountry = parentElm.querySelector('input[name="shipping_address[country]"]');
  let shippingProvince = parentElm.querySelector('select[name="shipping_address[province]"]');
  let shippingZip = parentElm.querySelector('input[name="shipping_address[zip]"]');
  let shippingCity = parentElm.querySelector('input[name="shipping_address[city]"]');
  let cartErr = 0;
  let cartErrNote = '';
  if (!shippingCity.value && !shippingZip.value ) {
    cartErrNote = 'Please enter your City and Postcode';
    cartErr = 1;
  }
  else if(!shippingZip.value) {
    cartErrNote = 'Please enter your Postcode';
    cartErr = 1;
  }
  else if(!shippingProvince.value) {
    cartErrNote = 'Please enter your State';
    cartErr = 1;
  }

  else if(!shippingCountry.value) {
    cartErrNote = 'Please enter your Country';
    cartErr = 1;
  }
  else if(!shippingCity.value) {
    cartErrNote = 'Please enter your City';
    cartErr = 1;
  }
  else {
    cartErrNote = '';
    cartErr = 0;
  }
  
  if (cartErr != 0) {
  
    shippingMessage.innerHTML = cartErrNote;
    shippingMessage.classList.add('error');
  }
  else {
    shippingMessage.classList.remove('error');
    var shippingAddress = {};
    shippingAddress.country = shippingCountry.value;
    shippingAddress.province = shippingProvince.value;
    shippingAddress.city = shippingCity.value;
    shippingAddress.zip = shippingZip.value;
    
    var queryString = Object.keys(shippingAddress).map(function (key) {
      return "".concat(encodeURIComponent("shipping_address[".concat(key, "]")), "=").concat(encodeURIComponent(shippingAddress[key]));
    }).join('&');
    $.ajax({
      type: "GET",
      url: '/cart/shipping_rates.json?'.concat(queryString),
      success: function(result){
        if(result.shipping_rates && result.shipping_rates.length){
          let arr = result.shipping_rates;
          arr.map(function(shipping_rates) {
            shippingMessage.classList.remove('error');
            shippingMessage.innerHTML = shipping_rates.name + ' : $' + shipping_rates.price;
          })
        }
      },
      error: function(err){
        shippingMessage.classList.add('error');
        shippingMessage.innerHTML = err.responseText;
      },
      dataType: 'json'
    });
  }
}


// size chart modal popup - sizeguide-modalcta .sizechart-modal

(function($) {
"use strict";
$(document).ready(function() {
        $('.sizeguide-modalcta').on('click', function(e) {
          e.preventDefault();
        $('body').addClass("sizechat-active");
    });
    $('.sizechart-close').on('click', function() {
        $('body').removeClass("sizechat-active");
    });
});
}(jQuery));

jQuery(document).on('click','.product__video-wrapper .product-video-trigger',function(){
  var videoObj =  $(this).next('video');
  if (videoObj) {
      jQuery(this).hide();
      videoObj[0].play();
  }
});
